import axios from "../axiosInstance";
import { FetchQuickBooksPeriodReportRangeResponse } from "./types";

export const fetchQuickBooksPeriodReportRange =
  async (): Promise<FetchQuickBooksPeriodReportRangeResponse> => {
    const response = await axios.get<FetchQuickBooksPeriodReportRangeResponse>(
      "/api/private/quickbooks-period-report/range",
    );
    return response.data;
  };
